module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-cs.da88ba2b87756e37dc71.svg";